import { apiCall } from '@/lib/api-client';

export interface MfaEnrollResponse {
  otpauthUrl: string;
  qrDataUrl: string;
  /** Manual entry code if QR scan fails. */
  secret: string;
}

export const mfaApi = {
  enroll: () =>
    apiCall<MfaEnrollResponse>('/auth/mfa/enroll', { method: 'POST' }),

  verify: (code: string) =>
    apiCall<{ mfaEnabled: true }>('/auth/mfa/verify', {
      method: 'POST',
      body: { code },
    }),

  disable: (password: string, code: string) =>
    apiCall<{ mfaEnabled: false }>('/auth/mfa/disable', {
      method: 'POST',
      body: { password, code },
    }),
};
